// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"7e515fab","17":"014b8835","179":"b90041bf","214":"2456b0bb","432":"7b3c1e03","453":"78294789","714":"fcfea352","797":"721974bf","972":"d5ec3978"}[chunkId] + ".chunk.js";
};